import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './Products.css';

const Products = () => {
    const location = useLocation();
    const [currentPage, setCurrentPage] = useState(1);
    const [category, setCategory] = useState(location.state?.category || 'all');
    const itemsPerPage = 12;

    const medicalBaseUrl = 'https://sakthivel.ascentbw.com/Files/Home/';

    const medicalProducts = [
        { id: 1, image: `${medicalBaseUrl}Product1.png`, title: "Surgical Implant Component", description: "High-precision medical grade implant component designed for surgical applications." },
        { id: 2, image: `${medicalBaseUrl}Product2.png`, title: "Precision Medical Housing", description: "Custom machined housing for sensitive medical diagnostic equipment." },
        { id: 3, image: `${medicalBaseUrl}Product3.png`, title: "Orthopedic Fixation Part", description: "Durable and bio-compatible fixation part for orthopedic surgeries." },
        { id: 4, image: `${medicalBaseUrl}Product4.png`, title: "Surgical Instrument Component", description: "Precision-engineered part for advanced surgical instrumentation." },
        { id: 5, image: `${medicalBaseUrl}Product5.png`, title: "Medical Device Bracket", description: "Stable and accurate mounting bracket for medical devices." },
        { id: 6, image: `${medicalBaseUrl}Product6.png`, title: "High-Precision Guide Pin", description: "Ultra-precise guide pin for surgical alignment and support." },
        { id: 7, image: `${medicalBaseUrl}Product7.png`, title: "Bio-Machined Component", description: "Specialized machined component using bio-compatible materials." },
        { id: 8, image: `${medicalBaseUrl}Product8.png`, title: "Specialized Surgical Tool", description: "Custom manufactured tool for specific surgical requirements." },
        { id: 9, image: `${medicalBaseUrl}Product9.png`, title: "Bio-Compatible Titanium Part", description: "Advanced titanium component for long-term medical implants." },
        { id: 10, image: `${medicalBaseUrl}Product10.png`, title: "Endoscopic Tool Handle", description: "Ergonomic and sterilizable handle for endoscopic surgical tools." },
    ];

    // Generate 36 general products
    const generalProducts = Array.from({ length: 24 }, (_, i) => ({
        id: i + 1,
        image: `https://sakthivel.ascentbw.com/Files/Product/Pro${i + 1}.png`,
        title: `Precision Component ${i + 1}`,
        description: 'High-quality industrial component manufactured with extreme precision and strict quality standards.'
    }));

    const allProducts = category === 'medical' ? medicalProducts : generalProducts;

    // Calculate total pages
    const totalPages = Math.ceil(allProducts.length / itemsPerPage);

    // Get current products
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentProducts = allProducts.slice(indexOfFirstItem, indexOfLastItem);

    // Change page
    const paginate = (pageNumber) => {
        setCurrentPage(pageNumber);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    useEffect(() => {
        if (location.state?.category) {
            setCategory(location.state.category);
            setCurrentPage(1); // Reset to first page when category changes
        }
    }, [location.state]);

    return (
        <div className="products-page">
            {/* Hero Section */}
            <section className="products-hero">
                <div className="container">
                    <div className="products-hero-content">
                        <h1>{category === 'medical' ? 'Medical Components We Deliver' : 'Precision Components We Deliver'}</h1>
                    </div>
                </div>
            </section>

            {/* Components Grid Section */}
            <section className="components-section section-padding">
                <div className="container">
                    <div className="components-grid">
                        {currentProducts.map((item) => (
                            <div key={item.id} className="component-card">
                                <div className="component-img-container">
                                    <img src={item.image} alt={item.title} title={item.title} />
                                </div>
                                <div className="component-info">
                                    <h3>{item.title}</h3>
                                    <p>{item.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Pagination */}
                    {totalPages > 1 && (
                        <div className="pagination-container">
                            <div className="pagination-numbers">
                                {Array.from({ length: totalPages }, (_, i) => (
                                    <button
                                        key={i + 1}
                                        onClick={() => paginate(i + 1)}
                                        className={`page-num ${currentPage === i + 1 ? 'active' : ''}`}
                                    >
                                        {i + 1}
                                    </button>
                                ))}
                            </div>
                            
                            {currentPage < totalPages && (
                                <button className="btn-next" onClick={() => paginate(currentPage + 1)}>
                                    Next
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginLeft: '8px' }}>
                                        <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </button>
                            )}
                        </div>
                    )}
                </div>
            </section>
        </div>
    );
};

export default Products;
